import { BaseRepository } from "@/repositories/base-repository"
import { type IPurchaseItem } from "@/interfaces/api/purchase-item.interface"

export class PurchaseItemRepository extends BaseRepository<IPurchaseItem> {
  protected resourcePath = "administration/purchase-items"
}
